import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SessionTimeoutService {
    constructor() {}
    private visible$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    resetSession: BehaviorSubject<boolean> = new BehaviorSubject(false);
    showSessionAlert() {
        this.visible$.next(true);
    }
    hideSessionAlert() {
        this.visible$.next(false);
    }
    getSessionAlertStatus() {
        return this.visible$.asObservable();
    }
}
